import { instance } from "../axios"

/**
 * 取得系統閾值設定
 * @param {object} config config
 * @returns {Promise} API response
 */
export function getCampaignThresholdConfiguration(config = {}) {
    return instance.request({
        url: "/systems/campaign-threshold-configuration/",
        method: "get",
        ...config,
    })
}

/**
 * 更新系統閾值設定
 * @param {object} config config
 * @returns {Promise} API response
 */
export function updateCampaignThresholdConfiguration(config = {}) {
    return instance.request({
        url: "/systems/campaign-threshold-configuration/",
        method: "put",
        ...config,
    })
}
